/*
 * <saint-comparison> (sections/custom-comparison-table.liquid with the SAINT design): the scroll indicator
 * under the comparison table on phones. Its red thumb is as wide as the share of the table in view and
 * moves with the scroll; it hides when the whole table fits. Without JavaScript the table still scrolls
 * and the indicator stays hidden.
 */
if (!customElements.get('saint-comparison')) {
  customElements.define(
    'saint-comparison',
    class SaintComparison extends HTMLElement {
      constructor() {
        super();
        this.update = this.update.bind(this);
      }

      connectedCallback() {
        this.scroller = this.querySelector('.comparison-table-scroll');
        this.indicator = this.querySelector('.saint-ct__scroll');
        if (!this.scroller || !this.indicator) return;

        this.abortController = new AbortController();
        this.scroller.addEventListener('scroll', theme.utils.throttle(this.update), { passive: true, signal: this.abortController.signal });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.scroller);
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      update() {
        const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
        const overflow = scrollWidth - clientWidth;
        this.indicator.hidden = overflow <= 1;
        if (overflow <= 1) return;
        const progress = Math.abs(scrollLeft) / overflow;
        this.indicator.style.setProperty('--saint-ct-thumb', (clientWidth / scrollWidth).toFixed(3));
        this.indicator.style.setProperty('--saint-ct-progress', (theme.config.rtl ? -progress : progress).toFixed(3));
      }
    }
  );
}
